import { Button, Flex, Form, message, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import { useAppDispatch } from '../../../../../app/hooks';
import { setCommonModal } from '../../../../../common/slices/modalSlice';
import {
  DateInput,
  FormInputItem,
  FormSelectInput,
  TextAreaInput,
} from '../../../../../components/common/FormItem/FormItems';
import { usePostFollowUpMutation } from '../../api/endpoints/clientEndpoints';
import { IClientFollowUp, IClientV2List } from '../../types/clientInterfaces';

type Props = {
  data: IClientV2List & {
    key: React.Key;
  };
};

const type = [
  {
    name: 'Phone Call',
    value: 'call',
  },
  {
    name: 'Whatsapp',
    value: 'whatsapp',
  },
  {
    name: 'Email',
    value: 'email',
  },
  {
    name: 'Visit',
    value: 'visit',
  },
];

const ClientFollowUp = ({ data }: Props) => {
  const [form] = useForm();
  const dispatch = useAppDispatch();

  const [post, { isLoading, isSuccess }] = usePostFollowUpMutation();

  const submit = (values: IClientFollowUp) => {
    const body: IClientFollowUp = {
      ...values,
      client_id: data.client_id,
      next_follow_up: values.next_follow_up
        ? dayjs(values.next_follow_up).format('YYYY-MM-DD')
        : undefined,

      scheduled_at: dayjs(values.scheduled_at).format('YYYY-MM-DD'),
    };
    post(body);
  };

  useEffect(() => {
    if (isSuccess) {
      dispatch(setCommonModal({ show: false }));
      message.success('Follow up added successfully');
      form.resetFields();
    }
  }, [isSuccess]);

  return (
    <Form form={form} layout='vertical' onFinish={submit}>
      <Row gutter={12}>
        <FormInputItem name='client_id' label='Client ID' initialValue={data.client_id} hidden />
        <FormSelectInput
          label='Follow up method'
          name={'type'}
          size={24}
          required
          placeholder='Select follow up method eg: whatsapp'
          data={type}
        />

        <FormInputItem
          name='purpose'
          label='Purpose'
          size={24}
          placeholder='Provide purpose eg: Ticket sell'
        />

        <DateInput
          allowClear
          name={'scheduled_at'}
          label='Followup date'
          rules={[{ required: true }]}
          size={12}
          initialValue={dayjs()}
        />
        <DateInput allowClear name={'next_follow_up'} label='Next follow up' size={12} />

        <TextAreaInput
          size={24}
          label='Follow up feedback'
          rules={[{ required: true }]}
          name={'feedback'}
        />

        <FormSelectInput
          label='Status'
          name={'status'}
          size={24}
          required
          placeholder='Follow status eg: done'
          data={[
            { name: 'Done', value: 'done' },
            { name: 'Pending', value: 'pending' },
            { name: 'Skipped', value: 'skipped' },
          ]}
        />
      </Row>
      <Flex justify='end'>
        <Button htmlType='submit' type='primary'>
          Submit
        </Button>
      </Flex>
    </Form>
  );
};

export default ClientFollowUp;
